import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { LineUserAccountsResponse } from '~/models/LineUserAccount';

const paths = {
  index: '/vendors/line_user_accounts'
};

type TIndex = () => SwrReturnType<LineUserAccountsResponse>;
type ReturnType = {
  index: TIndex;
};

export const useLineUserAccounts = (): ReturnType => {
  const index: TIndex = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, isLoading, error } = useSWR<LineUserAccountsResponse>(
      paths.index
    );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index };
};
